<i18n>
{
  "fr": {
    "infoRemmeber": "Rappel de la décomposition des surfaces",
    "infoVisit": "Informations sur la visite",
    "chooseContact": "Choisissez un contact",
    "chooseDecoEauPluv": "Choisissez un option",
    "vpt": "Visite Pendant Travaux",
    "ve": "Visite d’Entretien",
    "signataire":"Signataire",
    "addSignature":"Ajouter la signature",
    "signature":"Signature",
    "surfaceActive":"Surface Active (m²) ",
    "firstnameLastname": "Nom et Prénom:",
    "dateTime" : "Date et Heure:",
    "adresse": "Adresse",
    "controlResult": "Résultat du contrôle",
    "validate":"Valider",
    "surfaceParcelle":"Surface Parcelle (m²)",
    "leakFlowRate": "Débit de fuite prescrit (L/s) :",
    "leakFlowNotice": "Débit de fuite constaté (L/s) :",
    "rateVolume": "Volume prescrit (m³) :",
    "volumeNotice": "Volume constaté (m³) :",
    "deconnexionEuxPluvConst":"Déconnexion des eaux pluviales constatée jusqu'à la pluie décennale",
    "disconnectionWaterPrescrite":"Déconnexion des eaux pluviales prescrite jusqu'à la pluie décennale",
    "surfaceDisconnectConst":"Surface déconnectée constatée (m²) :",
    "surfaceDisconnectPrescrite":"Surface déconnectée prescrite (m²) :",
    "dateOfVisit": "Date de la visite :",
    "timeToVisit": "Heure de la visite :",
    "teamControl": "Equipe ayant effectuée le contrôle :",
    "contact": "Contact :",
    "dateOfNextVisit": "Date prochaine visite :",
    "Conforme": "conforme :",
    "NonConforme": "Non conforme",
    "technical_drawings": "Dessin Technique",
    "open_technical_drawing": "Ouvrir le dessin technique",
    "open_synoptic_drawing": "Ouvrir le synoptique",
    "download": "Télécharger"
  }
}
</i18n>
<template>
  <div class="panel-group">
    <div class="panel panel-info mg-b-15">
      <div class="panel-heading">
        <h3>{{ title }}</h3>
      </div>
      <div class="panel-body">
        <b-row>
          <b-col sm="12" md="4">
            <h4>{{ $t('infoRemmeber') }}</h4>
          </b-col>
          <b-col sm="12" md="4">
            <div class="form-group row">
              <label
                for="plotSurface"
                class="col-sm-7 col-md-4 col-form-label"
              >{{ $t('surfaceParcelle') }}</label>
              <div class="col-sm-5 col-md-6" v-if="property.conception">
                <input
                  id="plotSurface"
                  name="plotSurface"
                  type="text"
                  :maxlength="$MAX_255"
                  class="form-control"
                  :value="property.conception.plotSurface"
                  disabled
                />
              </div>
            </div>
          </b-col>

          <b-col sm="12" md="4">
            <div class="form-group row">
              <label
                for="activSurface"
                class="col-sm-7 col-md-4 col-form-label"
              >{{ $t('surfaceActive') }}</label>
              <div class="col-sm-5 col-md-6" v-if="property.conception">
                <input
                  id="activSurface"
                  name="activSurface"
                  type="text"
                  :maxlength="$MAX_255"
                  class="form-control"
                  :value="property.conception.activeSurface"
                  disabled
                />
              </div>
            </div>
          </b-col>
        </b-row>
        <hr />
        <b-form-group
          :label="$t('leakFlowRate')"
          label-cols="4"
          label-for="leakFlowRate"
          v-if="property.conception"
        >
          <b-form-input
            id="leakFlowRate"
            name="leakFlowRate"
            type="text"
            :maxlength="$MAX_255"
            :value="property.conception.leakFlowRate"
            disabled
          />
        </b-form-group>
        <b-form-group :label="$t('leakFlowNotice')" label-cols="4" label-for="leakFlowNotice">
          <b-form-input
            id="leakFlowNotice"
            name="leakFlowNotice"
            type="number"
            min="0"
            step=".01"
            v-model="getForm.leakFlowNotice"
          />
        </b-form-group>

        <b-form-group
          :label="$t('rateVolume')"
          label-cols="4"
          label-for="rateVolume"
          v-if="property.conception"
        >
          <b-form-input
            id="rateVolume"
            name="rateVolume"
            type="text"
            :maxlength="$MAX_255"
            :value="property.conception.rateVolume"
            disabled
          />
        </b-form-group>

        <b-form-group :label="$t('volumeNotice')" label-cols="4" label-for="volumeNotice">
          <b-form-input
            id="volumeNotice"
            name="volumeNotice"
            type="number"
            min="0"
            step=".01"
            v-model="getForm.volumeNotice"
          />
        </b-form-group>

        <b-form-group
          :label="$t('disconnectionWaterPrescrite')"
          label-cols="4"
          label-for="disconnectionWaterPrescrite"
        >
          <b-form-input
            id="disconnectionWaterPrescrite"
            name="disconnectionWaterPrescrite"
            type="text"
            :maxlength="$MAX_255"
            :value="getValueConception(property.conception.disconnectionOfRainwater)"
            disabled
          />
        </b-form-group>
        <b-form-group
          :label="$t('deconnexionEuxPluvConst')"
          label-cols="4"
          label-for="disconnectionOfRainwater"
        >
          <b-form-select
            id="disconnectionOfRainwater"
            name="disconnectionOfRainwater"
            v-model="getForm.disconnectionOfRainwater"
            size="sm"
            plain
          >
            <option
              v-for="contact in optionsdisconnectionOfRainwater"
              :key="contact.value"
              :value="contact.value"
            >{{ contact.text }}</option>
          </b-form-select>
        </b-form-group>
     
        <b-form-group :label="$t('surfaceDisconnectPrescrite')" label-cols="4" label-for="surfaceDisconnectPrescrite">
          <b-form-input
            id="surfaceDisconnectPrescrite"
            name="surfaceDisconnectPrescrite"
            type="text"
            :maxlength="$MAX_255"
            :value="property.conception.surfaceDisconnect"
            disabled
          />
        </b-form-group>
        <b-form-group :label="$t('surfaceDisconnectConst')" label-cols="4" label-for="surfaceDisconnect">
          <b-form-input
            id="surfaceDisconnect"
            name="surfaceDisconnect"
            type="number"
            min="0"
            step=".01"
            v-model="getForm.surfaceDisconnect"
          />
        </b-form-group>


     
      </div>
    </div>
    <div class="panel panel-info">
      <div class="panel-heading">{{ $t(typeForm) }}</div>
      <div class="panel-body">
        <h4>{{ $t('infoVisit') }}</h4>
        <div class="block">
          <b-form-group
            :label="$t('dateOfVisit')"
            label-cols="4"
            label-for="dateOfVisit"
            class="form-table"
          >
            <b-form-input
              id="dateOfVisit"
              name="dateOfVisit"
              type="date"
              v-model="getForm.dateOfVisit"
            />
            <span class="input-group-addon">
              <i class="fa fa-calendar"></i>
            </span>
          </b-form-group>
          <b-form-group :label="$t('timeToVisit')" label-cols="4" label-for="timeToVisit">
            <b-form-input
              id="timeToVisit"
              name="timeToVisit"
              type="time"
              v-model="getForm.timeToVisit"
            />
          </b-form-group>

          <b-form-group :label="$t('teamControl')" label-cols="4" label-for="teamControl">
            <b-form-input
              id="teamControl"
              name="teamControl"
              type="text"
              :maxlength="$MAX_255"
              v-model="getForm.teamControl"
            />
          </b-form-group>

          <b-form-group :label="$t('contact')" label-cols="4" label-for="contact">
            <b-form-select name="contact" v-model="getForm.contact" size="sm" plain>
              <option value="null">{{ $t('chooseContact') }}</option>
              <option
                v-for="contact in property.contacts"
                :key="contact.id"
                :value="contact.id"
              >{{ contact.name }} {{ contact.firstName }}</option>
            </b-form-select>
          </b-form-group>
          <template v-if="typeForm === this.typeVpt()">
            <SpecificVpt />
          </template>
          <template v-else-if="typeForm === this.typeVe()">
            <SpecificVe />
            <b-form-group
              :label="$t('dateOfNextVisit')"
              label-cols="4"
              label-for="dateOfNextVisit"
              class="form-table"
            >
              <b-form-input
                id="dateOfNextVisit"
                name="dateOfNextVisit"
                type="date"
                v-model="getForm.dateOfNextVisit"
              />
              <span class="input-group-addon">
                <i class="fa fa-calendar"></i>
              </span>
            </b-form-group>
          </template>
        </div>
      </div>
    </div>

    <Works />

    <div class="panel panel-info mg-b-15">
      <div class="panel-heading">{{ $t('technical_drawings') }}</div>
      <div class="panel-body">
        <div class="row">
          <div class="col-sm-6">
            <a v-on:click.prevent="openDrawio(technicalDesignUrl)" href="#" class="btn btn btn-cta btn-secondary btn-block">
              {{ $t('open_technical_drawing') }}
            </a>
          </div>
          <div class="col-sm-6">
            <a v-on:click.prevent="openDrawio(synopticDesignUrl)" href="#" class="btn btn btn-cta btn-secondary btn-block">
              {{ $t('open_synoptic_drawing') }}
            </a>
          </div>
          <input id="technicalDrawingXml" name="technicalDrawingXml" type="hidden" v-model="getForm.technicalDrawingXml">
          <input id="technicalDrawingImage" name="technicalDrawingImage" type="hidden" v-model="getForm.technicalDrawingImage">
          <input id="synopticDrawingXml" name="synopticDrawingXml" type="hidden" v-model="getForm.synopticDrawingXml">
          <input id="synopticDrawingImage" name="synopticDrawingImage" type="hidden" v-model="getForm.synopticDrawingImage">
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div v-if="isDrawingImageReady(this.getForm.technicalDrawingImage)" class="text-center">
              <br>
              <img v-bind:src="this.getForm.technicalDrawingImage" class="img-drawing">
              <br>
              <a v-if="this.controlId" v-bind:href="this.getFileUrl(this.controlId, technicalDrawingImageId)" target="_blank">{{ $t('download') }}</a>
            </div>
          </div>
          <div class="col-sm-6">

            <div v-if="isDrawingImageReady(this.getForm.synopticDrawingImage)" class="text-center">
              <br>
              <img v-bind:src="this.getForm.synopticDrawingImage" class="img-drawing">
              <br>
              <a v-if="this.controlId" v-bind:href="this.getFileUrl(this.controlId, synopticDrawingImageId)" target="_blank">{{ $t('download') }}</a>
            </div>
          </div>
        </div>       
      </div>
    </div>

    <div class="panel panel-info">
      <div class="panel-heading">{{ $t('signature') }}</div>
      <div class="panel-body">
        <div class="col-xs-12 col-md-4">
          <label>{{ $t('signataire') }} :</label>
        </div>
        <div class="col-xs-12 col-md-8">
          <select
            v-model="signator"
            v-on:change="onChangeSignatureContact($event)"
            class="form-control"
          >
            <option value>{{ $t('chooseContact') }}</option>
            <option
              v-for="contact in property.contacts"
              :key="contact.id"
              :value="((contact.name || '') + ' ' + (contact.firstName || '')).trim()"
            >{{ ((contact.name || '') + ' ' + (contact.firstName || '')).trim() }}</option>
            <option value="custom">Autre</option>
          </select>
        </div>

        <div class="row">&nbsp;</div>

        <div class="col-xs-12 col-md-4">
          <label></label>
        </div>
        <div class="col-xs-12 col-md-8">
          <input
            v-model="getForm.signator"
            v-bind:disabled="! signatureContactCustom"
            type="text"
            :maxlength="$MAX_255"
            class="form-control"
            v-on:blur="onSignator"
          />
        </div>

        <div class="row">&nbsp;</div>

        <div class="col-xs-12 col-md-4">
          <label></label>
        </div>
        <div class="col-xs-12 col-md-8">
          <button
            type="button"
            v-bind:class="{'disabled' : dispalyAddSignature }"
            class="btn btn btn-cta s-btn btn-secondary float-right"
            data-backdrop="static"
            data-keyboard="false"
            data-toggle="modal"
            data-target="#signatureModal"
          >{{ $t('addSignature') }}</button>
        </div>

        <div class="row">&nbsp;</div>

        <div class="col-xs-12 col-md-4">
          <label></label>
        </div>
        <div class="col-xs-12 col-md-8">
          <div>
            <img
              v-if="getForm.signature && getForm.signature.startsWith('data:')"
              v-bind:src="getForm.signature"
              class="signature"
            />
            <img
              v-else-if="this.signatureId !== null && this.signatureId !== 'undefined'"
              v-bind:src="'/fr/file/' + this.controlId + '/preview/' + this.signatureId"
              class="signature"
            />
          </div>
          <br />
          {{ signator }}
          <br />
          {{ getForm.signatureDateTime }}
        </div>

        <div
          class="modal"
          id="signatureModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="signatureModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-6">
                    <b>{{ $t('firstnameLastname') }}</b>
                    {{ signator }}
                    <br />
                    <b>{{ $t('dateTime') }} :</b>
                    {{ currentDateTime() }}
                    <br />
                  </div>
                  <div class="col-sm-6">
                    <b>{{ $t('adresse') }} :</b>
                    {{ property.address.street + ', ' + property.address.numberStreet + ', ' + property.address.zipCode+ ', ' + property.address.town}}
                    <br />
                    <b>{{ $t('controlResult') }} :</b>
                    {{ getForm.result ? $t('Conforme'): $t('NonConforme') }}
                    <br />
                  </div>
                </div>

                <br />

                <SignaturePad
                  v-bind:signature="getForm.signature"
                  v-bind:signatureDateTime="getForm.signatureDateTime"
                  v-bind:signatureDateTimeOriginal="getForm.signatureDateTime"
                  v-on:emitSignaturePadData="onSignaturePadData"
                ></SignaturePad>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >{{ $t('validate') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Works from '../fields/work/Works.vue';
import SpecificVpt from './SpecificVpt.vue';
import SpecificVe from './SpecificVe.vue';
import { TYPE_VPT, TYPE_VE } from '../../constants/params';
import { mapState, mapGetters } from 'vuex';
import SignaturePad from '../../communs/SignaturePad';
import { currentDateTime } from '@/utils/formatDate.js';
import { getEndpoint } from '../../store/endpoints';
import axios from 'axios';

export default {
  Name: 'CommonFields',
  props: {
    title: { type: String, required: true },
  },
  components: {
    Works,
    SpecificVpt,
    SpecificVe,
    SignaturePad,
  },
  data: () => ({
    optionsdisconnectionOfRainwater: [
      { text: 'Aucune', value: 'none' },
      {
        text: "Déconnexion totale",
        value: 'totalDisconnection',
      },
      {
        text: "Déconnexion partielle",
        value: 'partialDisconnection',
      },
    ],
    signatureId: null,
    signator: null,
    signatureContactCustom: false,
    dispalyAddSignature: true,
    tempUuid: null,
    userTempToken: null,
    technicalDesignUrl: null,
    synopticDesignUrl: null,
    drawioConfig: null,
    technicalDrawingXmlId: null,
    synopticDrawingXmlId: null,
    technicalDrawingImageId: null,
    synopticDrawingImageId: null,
  }),
  computed: {
    ...mapState({
      typeForm: state => state.app.typeForm,
      property: state => state.refProperties.property,
      controlId: state => state.route.params.controlId,
    }),
    ...mapGetters(['getForm']),
  },
  methods: {
    currentDateTime,
    isDrawingImageReady(drawingImage)
    {
      return drawingImage && drawingImage.startsWith('data:');
    },
    onSignator() {
      if (this.getForm.signator) {
        this.dispalyAddSignature = false;
      } else {
        this.dispalyAddSignature = true;
      }
    },
    onChangeSignatureContact(event) {
      if (event.target.value === 'custom') {
        this.signator = '';
        this.getForm.signator = this.signator;
        this.signatureContactCustom = true;
        this.dispalyAddSignature = true;
      } else {
        this.signator = event.target.value;
        this.getForm.signator = this.signator;
        this.signatureContactCustom = false;
        this.dispalyAddSignature = false;
      }
      if (!this.signator) {
        this.dispalyAddSignature = true;
      }
    },
    onSignaturePadData(data) {
      this.getForm.signature = data.signature;
      this.getForm.signatureDateTime = data.signatureDateTime;
      this.$forceUpdate();
    },
    typeVpt: function() {
      return TYPE_VPT;
    },
    typeVe: function() {
      return TYPE_VE;
    },
    getValueConception(value) {
      if (value) {
        let arr = [
          { text: 'Aucune', value: 'none' },
          {
            text: "Déconnexion totale",
            value: 'totalDisconnection',
          },
          {
            text: "Déconnexion partielle",
            value: 'partialDisconnection',
          },
        ];
        let obj = arr.find(p => p.value === value);
        if (obj) {
          return obj.text;
        } else {
          return 'Aucune';
        }
      }
    },
    getTmpDiagram: function () {
      // Get the saved temporay diagrams contents (xml and base64 for images) and set digrams fields values
      let _this = this;

      let technicalDesignId = `technical-design-${this.tempUuid}`;
      let synopticDesignId = `synoptic-design-${this.tempUuid}`;

      let technicalDesignUrl = this.drawioConfig.widgetHost.replace('diagramId', technicalDesignId) + "?temp-token=" + this.userTempToken;
      let synopticDesignUrl = this.drawioConfig.widgetHost.replace('diagramId', synopticDesignId) + "?temp-token="  + this.userTempToken;

      // Get technical diagram and set fields values
      axios.get(technicalDesignUrl).then(response => {
        _this.getForm.technicalDrawingXml = response.data.xml;
        _this.getForm.technicalDrawingImage = response.data.base64Image;
        this.getDrawioConfig(this.userTempToken);
        this.$forceUpdate();
      })
      .catch(error => {
        console.log(error);
      });

      // Get synoptic diagram and set fields values
      axios.get(synopticDesignUrl).then(response => {
        _this.getForm.synopticDrawingXml = response.data.xml;
        _this.getForm.synopticDrawingImage = response.data.base64Image;
        this.getDrawioConfig(this.userTempToken);
        this.$forceUpdate();
      })
      .catch(error => {
        console.log(error);
      });
    },
    getFile: function (requestId, fileId, formKey, type='', encode = '') {
      // Get diagrams file content (xml, and base64 for images) and set diagrams fields values
      let _this = this;

      const endpoint = `${getEndpoint('file', null, requestId, fileId, null).absoluteDownloadUrl}?encode=${encode}`;

      axios.get(endpoint).then(response => {
          _this.getForm[formKey] = response.data;
          if (type == 'png') {
            _this.getForm[formKey] = 'data:image/png;base64,' + _this.getForm[formKey];
          }
      })
      .catch(error => {
        alert(error);
      });
    },
    getPropertyFile: function (fileId, formKey, type='', encode = '') {
      // Get diagrams file content (xml, and base64 for images) and set diagrams fields values
      let _this = this;

      const endpoint = `${getEndpoint('drawio', null, this.controlId, fileId, null).downloadPropertyFile}?encode=${encode}&temp-token=${this.userTempToken}`;

      axios.get(endpoint).then(response => {
          _this.getForm[formKey] = response.data;
          if (type == 'png') {
            _this.getForm[formKey] = 'data:image/png;base64,' + _this.getForm[formKey];
            _this.$forceUpdate();
          }
      })
      .catch(error => {
        alert(error);
      });
    },
    setUserTempToken: function () {
      // Get a user temporay token
      let _this = this;

      const endpoint = getEndpoint('userTempToken', null, null, null, null).get;

      axios.get(endpoint).then(response => {
          _this.userTempToken = response.data.value;
          this.$forceUpdate();
          _this.getDrawioConfig(_this.userTempToken);
      })
      .catch(error => {
        console.log(error);
      });
    },
    setDrawioUrls (drawioConfig, userTempToken) {
      // Init the drawio urls for technical and synoptic design
      let technicalDesignId = `technical-design-${this.tempUuid}`;
      let synopticDesignId = `synoptic-design-${this.tempUuid}`;

      if (this.getForm.technicalDrawingXml && this.technicalDrawingXmlId) {
        this.technicalDesignUrl = `${drawioConfig.url}/?splash=0&lang=fr&drafts=0&gapi=0&db=0&od=0&tr=0&gh=0&gl=0&browser=0&p=&get-url=${this.getDrawioGetUrl(this.technicalDrawingXmlId)}&post-url=${drawioConfig.widgetHost.replace('diagramId', technicalDesignId)}?temp-token=${userTempToken}`;
      }
      else if(this.getForm.technicalDrawingXml && !this.technicalDrawingXmlId)
      {
        this.technicalDesignUrl = `${drawioConfig.url}/?splash=0&lang=fr&drafts=0&gapi=0&db=0&od=0&tr=0&gh=0&gl=0&browser=0&p=&get-url=${drawioConfig.widgetHost.replace('diagramId', technicalDesignId)}/xml?temp-token=${userTempToken}&post-url=${drawioConfig.widgetHost.replace('diagramId', technicalDesignId)}?temp-token=${userTempToken}`;
      }
      else{
        if (this.property && this.property.technicalDrawingXml && this.property.technicalDrawingXml.id) {
          this.technicalDesignUrl = `${drawioConfig.url}/?splash=0&lang=fr&drafts=0&gapi=0&db=0&od=0&tr=0&gh=0&gl=0&browser=0&p=&get-url=${this.getDrawioPropertyUrl(this.property.technicalDrawingXml.id)}&post-url=${drawioConfig.widgetHost.replace('diagramId', technicalDesignId)}?temp-token=${userTempToken}`;
          this.getPropertyFile(this.property.technicalDrawingImage.id, 'technicalDrawingImage', 'png', 'base64');
          this.getPropertyFile(this.property.technicalDrawingXml.id, 'technicalDrawingXml');
        }else{
          this.technicalDesignUrl = `${drawioConfig.url}/?splash=0&lang=fr&drafts=0&gapi=0&db=0&od=0&tr=0&gh=0&gl=0&browser=0&p=&get-url=${this.getDrawioTemplateUrl('technique.drawio')}&post-url=${drawioConfig.widgetHost.replace('diagramId', technicalDesignId)}?temp-token=${userTempToken}`;
        }
      }

      if (this.getForm.synopticDrawingXml && this.synopticDrawingXmlId) {
        this.synopticDesignUrl = `${drawioConfig.url}/?splash=0&lang=fr&drafts=0&gapi=0&db=0&od=0&tr=0&gh=0&gl=0&browser=0&p=&get-url=${this.getDrawioGetUrl(this.synopticDrawingXmlId)}&post-url=${drawioConfig.widgetHost.replace('diagramId', synopticDesignId)}?temp-token=${userTempToken}`;
      }
      else if(this.getForm.synopticDrawingXml && !this.synopticDrawingXmlId)
      {
        this.synopticDesignUrl = `${drawioConfig.url}/?splash=0&lang=fr&drafts=0&gapi=0&db=0&od=0&tr=0&gh=0&gl=0&browser=0&p=&get-url=${drawioConfig.widgetHost.replace('diagramId', synopticDesignId)}/xml?temp-token=${userTempToken}&post-url=${drawioConfig.widgetHost.replace('diagramId', synopticDesignId)}?temp-token=${userTempToken}`;
      }
      else{
        if (this.property && this.property.synopticDrawingXml && this.property.synopticDrawingXml.id) {
          this.synopticDesignUrl = `${drawioConfig.url}/?splash=0&lang=fr&drafts=0&gapi=0&db=0&od=0&tr=0&gh=0&gl=0&browser=0&p=&get-url=${this.getDrawioPropertyUrl(this.property.synopticDrawingXml.id)}&post-url=${drawioConfig.widgetHost.replace('diagramId', synopticDesignId)}?temp-token=${userTempToken}`;
          this.getPropertyFile(this.property.synopticDrawingImage.id, 'synopticDrawingImage', 'png', 'base64');
          this.getPropertyFile(this.property.synopticDrawingXml.id, 'synopticDrawingXml');
        }else{
          this.synopticDesignUrl = `${drawioConfig.url}/?splash=0&lang=fr&drafts=0&gapi=0&db=0&od=0&tr=0&gh=0&gl=0&browser=0&p=&get-url=${this.getDrawioTemplateUrl('synoptique.drawio')}&post-url=${drawioConfig.widgetHost.replace('diagramId', synopticDesignId)}?temp-token=${userTempToken}`;
        }
      }

      this.$forceUpdate();
    },
    getDrawioConfig(userTempToken) {
      // Get the drawio configuration
      let _this = this;

      const endpoint = getEndpoint('drawio', null, this.controlId, null, null, userTempToken).config;

      axios.get(endpoint).then(response => {
          _this.drawioConfig = response.data;
          this.$forceUpdate();
          _this.setDrawioUrls(_this.drawioConfig, _this.userTempToken);
      })
      .catch(error => {
        console.log(error);
      });
    },
    uuidv4() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    getDrawioGetUrl: function (fileId) {
      // Get diagrams file url
      return `${window.location.origin}${getEndpoint('drawio', null, this.controlId, fileId).file}?temp-token=${this.userTempToken}`;
    },
    getDrawioTemplateUrl: function (templateFilename) {
      // Get diagrams file url
      return `${window.location.origin}${getEndpoint('drawio', null, this.controlId, null, null, null, templateFilename).template}?temp-token=${this.userTempToken}`;
    },
    openDrawio(url) {
      let _this = this;

      var drawioWindow = window.open(url, '_blank');

      var loop = setInterval(function() {   
        if(drawioWindow.closed) {  
            clearInterval(loop);  
            _this.getTmpDiagram();
        }  
      }, 500);
    },
    getFileUrl: function (requestId, fileId) {
      // Get diagrams file content (xml, and base64 for images) and set diagrams fields values
      
      return getEndpoint('file', null, requestId, fileId, null).absoluteDownloadUrl;
    },
    getDrawioPropertyUrl: function (fileId) {
      // Get diagrams file url
      return `${window.location.origin}${getEndpoint('drawio', null, this.controlId, fileId, null, null, null).downloadPropertyFile}?temp-token=${this.userTempToken}`;
    },
  },
  created: function() {
    if (this.getForm.signature) {
      this.signatureId = this.getForm.signature;
      this.signator = this.getForm.signator;
    }

    // Init diagrams fields (xml, base64 for images) if exists

    if (this.getForm.technicalDrawingXml) {
      this.technicalDrawingXmlId = this.getForm.technicalDrawingXml;
      this.getFile(this.controlId, this.getForm.technicalDrawingXml, 'technicalDrawingXml');
    }

    if (this.getForm.technicalDrawingImage) {
      this.technicalDrawingImageId = this.getForm.technicalDrawingImage;
      this.getFile(this.controlId, this.getForm.technicalDrawingImage, 'technicalDrawingImage', 'png', 'base64');
    }

    if (this.getForm.synopticDrawingXml) {
      this.synopticDrawingXmlId = this.getForm.synopticDrawingXml;
      this.getFile(this.controlId, this.getForm.synopticDrawingXml, 'synopticDrawingXml');
    }

    if (this.getForm.synopticDrawingImage) {
      this.synopticDrawingImageId = this.getForm.synopticDrawingImage;
      this.getFile(this.controlId, this.getForm.synopticDrawingImage, 'synopticDrawingImage', 'png', 'base64');
    }

    // Init the user temp token
    this.setUserTempToken();

    // Init a temporary uuid for drawio use
    this.tempUuid = this.uuidv4();
  },
};
</script>

<style scoped>
.signature {
  width: 50%;
}
.img-drawing {
  height: 200px;
}
</style>